import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { InputTreeData } from './types';

@Injectable({
    providedIn: 'root',
})
export class TreeViewCellService {
    static $name = 'dlTreeViewCellService';

    prepairTreeDataForCell<T>(input: T[], attributeName: string) {
        for (const data of input) {
            if (attributeName in data) {
                const tree = data[attributeName]?.[0] as InputTreeData;
                const treeNodeCopy = _.cloneDeep<InputTreeData>(tree);
                this.extendNode(treeNodeCopy);
                data['treeData'] = treeNodeCopy;
            }
        }
    }

    private extendNode<T extends InputTreeData>(node: T) {
        node.name = node.displayText;
        node.items = node.children;

        for (const child of node?.items ?? []) {
            this.extendNode(child);
        }
    }
}
